import { Helmet } from "react-helmet-async";

/**
 * Reusable per-route SEO primitive. Writes exactly one <title>, one meta
 * description, one canonical link + Open Graph/Twitter tags. Overrides the
 * generic reserve-tags in /public/index.html when mounted — react-helmet-async
 * dedupes by key so no duplicate <title> can appear in pre-rendered HTML.
 *
 * Props:
 *  - title: Required. The <title> (also used for og/twitter title).
 *  - description: Required for public SEO pages.
 *  - path: Required. Pathname (leading slash). Used to build canonical + og:url.
 *  - image: Optional absolute URL to override the default OG image.
 *  - noIndex: If true, emits <meta name="robots" content="noindex,nofollow">.
 *  - jsonLd: Optional object serialized to JSON-LD script tag.
 */
const SITE = "https://foton.enduroskola.se";

export default function Seo({ title, description, path = "/", image, noIndex = false, jsonLd }) {
  const url = `${SITE}${path.startsWith("/") ? path : `/${path}`}`;
  const img = image || `${SITE}/og-image.jpg`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={img} />

      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
